import React from 'react';
import './Advisors.css';
import siteConfig from '../../configuration/siteConfiguration';

const baseImageUrl = `${siteConfig.assetBaseUrl}/icons/verticals-we-power/default`;

const advisorData = [
  {
    title: "Healthcare & Clinical Governance",
    description: "hospital leaders, public health experts, and compliance professionals",
    icon: `${baseImageUrl}/Healthcare.svg`
  },
  {
    title: "Manufacturing & Industrial Operations",
    description: "plant, operations, and reliability experts",
    icon: `${baseImageUrl}/Manufacturing.png`
  },
  {
    title: "Legal, Policy & Compliance",
    description: "senior legal professionals and regulatory specialists",
    icon: `${baseImageUrl}/Legal.svg`
  },
  {
    title: "Academic & Technical Institutions",
    description: "advisors from IITs, IIMs, and public research bodies",
    icon: `${baseImageUrl}/Regulations.svg`
  }
];

const AdvisorCard = ({ icon, title, description }) => {
  return (
    <div className="advisor-card">
      <img src={icon} alt="Advisor Icon" className="advisor-icon" />
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
};

const Advisors = () => {
  return (
    <>
      <section className="advisors-section">
        <div className="advisors-main-content">
          <div className="advisors-text-content">
            <h3>- ADVISORS</h3>
            <h2>Our backbone</h2>
            <p>
              Cognitva is backed by a trusted circle of domain leaders and regulatory
              experts who guide our platform strategy, vertical alignment, and go-to-market execution.
            </p>
          </div>
          <div className="advisors-cards-container">
            {advisorData.map((advisor, index) => (
              <AdvisorCard icon={advisor.icon} key={index} title={advisor.title} description={advisor.description} />
            ))}
          </div>
        </div>

      </section>
      <div className="advisors-divider"></div>
    </>
  );
};

export default Advisors; 